import React from 'react'
import { useSiteSettings } from '../../hooks/useSiteSettings'
import { isNullOrWhiteSpace } from '../../utilities/string'

export const GtmNoScript = () => {
  const siteSettings = useSiteSettings()

  const gtmId = siteSettings?.gtmId ?? process.env.GATSBY_GOOGLE_TAG_MANAGER_ID

  return !isNullOrWhiteSpace(gtmId) && process.env.NODE_ENV === 'production' ? (
    <noscript>
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{
          display: 'none',
          visibility: 'hidden',
        }}
      ></iframe>
    </noscript>
  ) : null
}
